<template>
  <div>
    <PrimaryButton @click.native="openDialog" class="mb-5" full-width light>
      Add Language
    </PrimaryButton>
    <AddLanguageDialog v-if="isOpen" @close="closeDialog" />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import AddLanguageDialog from "@/views/profile/QuestionsAndAnswers/steps/LanguagesAndSkills/Languages/dialogs/AddLanguageDialog";

export default {
  name: "AddLanguageAction",
  components: {
    PrimaryButton,
    AddLanguageDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
